import NextImage from 'next/image';
import {chakra} from '@chakra-ui/system';

export const Image = chakra(NextImage, {
  shouldForwardProp: (prop) =>
    ['src', 'alt', 'width', 'height', 'layout', 'priority', 'quality', 'title'].includes(prop),
});
